import { render, staticRenderFns } from "./price-cell.vue?vue&type=template&id=55ef330c&"
import script from "./price-cell.vue?vue&type=script&lang=ts&"
export * from "./price-cell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports